import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import {
  AddressController,
  CityProps,
  CountryProps,
  StateProps,
} from "../../../domain/models/address.model";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteAddressControler implements AddressController {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient
  ) {}

  async loadStates(): Promise<StateProps[]> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/states`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async loadCountries(): Promise<CountryProps[]> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/countries`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async loadCities(initials: number): Promise<CityProps[]> {
    if (initials === 0) {
      return [];
    }
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/cities/${initials}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
